import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useFileInputContext } from '@components/form/photos/FileInputContext'
import Icon from '@components/shared/Icon'
import Progress from '@components/progress/Progress'
import mix from '@utils/styles/mix'
import { DROPZONE_ACCEPTED_FORMATS } from '@constants/photos'

import styles from 'styles/add/DragDropArea.module.css'

const DragDropArea = ({ children, progress }) => {
    const {
        MessageHelper, messages,
        files, setFiles, limit,
        callbacks: { onFileEntry } = {}} = useFileInputContext()

    const count = files.length
    const spaceLeft = limit - count
    const onDrop = useCallback((acceptedFiles) => {
        const incomingCount = acceptedFiles.length

        if (spaceLeft < 0) {
            return MessageHelper.message(`${messages.limitReached} ${limit}.`)
        }

        if (incomingCount > spaceLeft) {
            acceptedFiles = acceptedFiles.slice(0, spaceLeft)
            MessageHelper.message(`${messages.limitReached} ${limit}.`)
        }

        const newFiles = files.concat(onFileEntry
            ? onFileEntry(acceptedFiles)
            : acceptedFiles)

        setFiles(newFiles)
    }, [files?.length])

    const { getRootProps, getInputProps } = useDropzone({onDrop, accept: DROPZONE_ACCEPTED_FORMATS }) // isDragActive
    const longActionInProgress = progress !== null

    return (
        <div className={mix([styles.wrap, longActionInProgress && styles.disabled])}>
            <div {...getRootProps()}>
                <div>
                    <input {...getInputProps()} />
                    <p className={styles.btn}><Icon>add</Icon></p>
                </div>
            </div>

            { children }
            { longActionInProgress && <Progress progress={progress} /> }
            <p className={styles.count}>{messages.spaceLeft}: {spaceLeft}</p>
        </div>

    )
}

export default DragDropArea